export default function getReadableCron(cron: string): string {
	if (cron?.endsWith(' * * *')) {
		return 'daily';
	}

	if (cron?.startsWith('0 0 * * ')) {
		return 'weekly';
	}

	switch (cron) {
		case '':
			return 'manually';

		case '0 0 * * *':
			return 'daily';

		case '0 0 * * MON':
			return 'weekly';

		case '0 0 1 * *':
			return 'monthly';

		default:
			return 'manually';
	}
}
